import React from 'react';
import PropTypes from 'prop-types';

import { newAiringRow, CHANNEL_OPTIONS } from '../../../utils/radioShowForm';
import { madridToday } from '../../../utils/radioTime';
import { FieldErrors } from './RadioFields';

/*
The air times of a show: repeatable (date, time, channel) rows, entered and shown in
Madrid time. utils/radioShowForm.js converts them to UTC on save, catches a repeated
(date, time, channel), and sends the list only when it changed.
*/
const RadioAiringsField = ({
  rows, onChange, errors, defaultChannel,
}) => {
  const updateRow = (key, patch) => onChange(rows.map(row => (row.key === key ? { ...row, ...patch } : row)));
  const removeRow = key => onChange(rows.filter(row => row.key !== key));
  const addRow = () => onChange([...rows, newAiringRow({ date: madridToday(), channel: defaultChannel || '1' })]);

  return (
    <div>
      <p className="radio-help" style={{ marginBottom: 10 }}>
        Madrid time (Europe/Madrid). Saved in UTC, so summer and winter time are handled for you.
      </p>
      {rows.length === 0 ? <p className="radio-notice" style={{ marginBottom: 10 }}>No air times.</p> : null}
      {rows.map((row, index) => {
        const rowError = errors[`airings.${index}`];
        return (
          <div key={row.key}>
            <div className={`radio-airing-row${rowError ? ' has-error' : ''}`}>
              <input
                type="date"
                aria-label={`Air date ${index + 1}`}
                className="radio-input"
                value={row.date}
                onChange={event => updateRow(row.key, { date: event.target.value })}
              />
              <input
                type="time"
                step="60"
                aria-label={`Air time ${index + 1}`}
                className="radio-input"
                value={row.time}
                onChange={event => updateRow(row.key, { time: event.target.value })}
              />
              <select
                aria-label={`Air channel ${index + 1}`}
                className="radio-input"
                value={row.channel}
                onChange={event => updateRow(row.key, { channel: event.target.value })}
              >
                {CHANNEL_OPTIONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
              </select>
              <div>
                <button type="button" className="radio-button is-ghost is-small" onClick={() => removeRow(row.key)}>
                  Remove
                </button>
              </div>
            </div>
            <FieldErrors error={rowError} />
          </div>
        );
      })}
      <button type="button" className="radio-button is-ghost is-small" onClick={addRow}>
        Add air time
      </button>
      <FieldErrors error={errors.airings} />
    </div>
  );
};

RadioAiringsField.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    date: PropTypes.string,
    time: PropTypes.string,
    channel: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  // { airings, 'airings.<index>' }: the client's messages and the server's for 'airings'.
  errors: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])),
  defaultChannel: PropTypes.string,
};

RadioAiringsField.defaultProps = {
  errors: {},
  defaultChannel: '1',
};

export default RadioAiringsField;
